<template>
  <NtModal no-dismiss ref="modal" size="sm" heading="Uploading Files...">
    <div v-if="activeUpload">
      <div class="flex w-full gap-3 mb-3">
        <p class="truncate grow">{{ activeUpload.name }}</p>
        <p>{{ Math.floor((100 / activeUpload.size) * activeUpload.transferred) }}%</p>
      </div>
      <div class="h-8 bg-neutral-200 dark:bg-neutral-700 rounded-sm">
        <div
          class="h-8 bg-accent-600 dark:bg-accent-700 rounded-sm overflow-hidden"
          :style="{ width: `${(100 / activeUpload.size) * activeUpload.transferred}%` }">
          <div
            class="h-8 w-full bg-linear-to-r from-accent-600 via-accent-400 to-accent-600 dark:from-accent-700 dark:via-accent-500 dark:to-accent-700 animate-swipe"></div>
        </div>
      </div>
    </div>
    <template #footer>
      <NtButton icon="fa-external-link" level="primary" @click="openInNewTab">Continue in New Tab</NtButton>
    </template>
  </NtModal>
</template>

<script>
import { mapState } from 'pinia'
import NtModal from './NtModal.vue'
import NtButton from './NtButton.vue'
import { useSystemStore } from '@/stores/system'
export default {
  components: { NtModal, NtButton },
  computed: {
    ...mapState(useSystemStore, ['activeUpload'])
  },
  methods: {
    openInNewTab() {
      window.open(window.location.href, '_blank')
    }
  },
  watch: {
    activeUpload(upload) {
      if (upload) {
        this.$refs.modal.open()
        return
      }

      this.$refs.modal.close()
    }
  }
}
</script>
